import {
  Box,
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import {
  deletePartitionThunk,
  getPartitionsByTrayThunk,
} from "store/reducers/vending";
import PartitionCrudDialog from "pages/vending/partition/dialogs/PartitionCrudDialog";
import PartitionItem from "pages/vending/partition/list/PartitionItem";
import { LoadingButton } from "@mui/lab";

const PartitionList = ({ tray }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const vendingState = useSelector((state) => state.vending);
  const [currentItem, setCurrentItem] = React.useState(null);

  const { partitions, deletePartitionLoading } = useSelector(
    (state) => state.vending
  );

  useEffect(() => {
    dispatch(getPartitionsByTrayThunk(tray.id));
  }, [tray]);

  const handleDelete = (id) => {
    dispatch(deletePartitionThunk({ id, tray: tray.id }));
  };

  const handleEditClick = (item) => {
    console.log("In console");
    setCurrentItem(item);
    setOpenUpdateDialog(true);
  };

  const [openUpdateDialog, setOpenUpdateDialog] = React.useState(false);
  const handleUpdateDialogClose = () => {
    setOpenUpdateDialog(false);
  };

  return (
    <Box>
      {partitions[tray.id]?.length > 0 && (
        <Box
          sx={{ backgroundColor: "#e7ebf0", borderRadius: 1, flex: 1, mt: 1 }}
          padding={0.5}
        >
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 140 }} align="center">
                    {isSmallScreen ? "Number" : "Partition number"}
                  </TableCell>
                  <TableCell align="center" sx={{ minWidth: 160 }}>
                    {isSmallScreen ? "Desc" : "Description"}
                  </TableCell>
                  <TableCell align="center">Max count</TableCell>
                  <TableCell align="center">Notification trigger</TableCell>
                  <TableCell sx={{ width: 80 }}>&nbsp;</TableCell>
                  <TableCell sx={{ width: 80 }}>&nbsp;</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {partitions[tray.id]?.map((partition) => (
                  <TableRow
                    key={partition.id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell component="th" scope="row" align="center">
                      {partition.number}
                    </TableCell>
                    <TableCell align="center">
                      {partition.desc?.length > 0 ? partition.desc : "-"}
                    </TableCell>
                    <TableCell align="center">{partition.max_count}</TableCell>
                    <TableCell align="center">{partition.notification_limit}</TableCell>

                    <TableCell align="center">
                      <Button
                        color="info"
                        variant="outlined"
                        size="small"
                        onClick={() => handleEditClick(partition)}
                      >
                        Edit
                      </Button>
                    </TableCell>
                    <TableCell align="center">
                      <LoadingButton
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={() => {
                          handleDelete(partition.id);
                        }}
                        loading={deletePartitionLoading[partition.id]}
                      >
                        Delete
                      </LoadingButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      <Stack direction="row" justifyContent="end">
        <Button
          size="small"
          variant="outlined"
          sx={{ mt: 1 }}
          onClick={() => setOpenUpdateDialog(true)}
        >
          Add new partition
        </Button>
      </Stack>
      <PartitionCrudDialog
        open={openUpdateDialog}
        handleClose={handleUpdateDialogClose}
        tray_id={tray.id}
        partition={currentItem}
        setCurrentItem={setCurrentItem}
        number={
          vendingState.partitions[tray.id]?.length > 0
            ? vendingState.partitions[tray.id][
                vendingState.partitions[tray.id]?.length - 1
              ].number + 1
            : 1
        }
      />
    </Box>
  );
};

export default PartitionList;
